<template>
  <div class="chooseNormal-container">
    <div v-for="(item, index) in list" :key="index" class="column">
      <div class="title" style="display:flex;align-items:center">
        {{ item.value }}
      </div>
      <babyMutipul
        :margin-right="100"
        :margin-bottom="8"
        :items.sync="item.data"
        :max-length="5"
        :current-length="currentLength"
        style="flex:1"
      ></babyMutipul>
    </div>
  </div>
</template>
<script>
import babyMutipul from '@/components/common/babyMutipul/babyMutipul';

export default {
  components: {
    babyMutipul
  },
  props: {
    symptom_list: [Array]
  },
  data() {
    return {
      tempers: [
        {label: '体温<36°C', value: 1},
        {label: '36°C≤体温≤37.4°C', value: 2},
        {label: '37.4°C<体温<38.5°C', value: 3},
        {label: '体温≥38.5°C', value: 4}
        // 提交
      ],
      form: {
        _temper: 1
      },
      list: []
    };
  },
  computed: {
    currentLength() {
      function computedNum(list) {
        return list.reduce((total, prev) => total + (prev.active ? 1 : 0), 0);
      }
      return this.list.reduce(
        (total, prev) => total + computedNum(prev.data),
        0
      );
    }
  },
  watch: {
    symptom_list(v) {
      this.list = v;
    }
  }
};
</script>
<style lang="scss" scoped>
.chooseNormal-container {
  background-color: #fff;
  padding: 30px 10px 8px 10px;
  .column {
    background-color: #f2f6ff;
    display: flex;
    margin-bottom: 8px;
    font-size: 16px;
    padding-top: 8px;
    &:last-child {
      margin-bottom: 0;
    }
    .title {
      position: relative;
      width: 167px;
      box-sizing: border-box;
      color: #4b90ff;
      padding-left: 10px;
      margin-top: -8px;
      font-weight: bold;
      .require {
        position: absolute;
        left: 2px;
        top: -4px;
        color: #dd331d;
      }
      .big-tip {
        color: #fff;
        background-color: red;
        padding: 5px 20px;
        border-radius: 5px;
        margin-left: 5px;
      }
    }
  }
}
</style>
